import * as React from 'react';
import {clsx} from 'clsx';
import {useState} from 'react';

type InputProps = {
	text: string;
	name: string;
	type?: string;
	register: any;
	error?: string;
	className?: string;
	textAreaClass?: string;
	isRequired?: boolean;
}

export function TextArea({
	text,
	name,
	register,
	error,
	className,
	textAreaClass,
	isRequired = false
}: InputProps) {

	const inputId = `input-${name}`;
	const [hasValue, setHasValue] = useState(false);
	const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		// const ta = e.target;
		e.target.style.height = 'auto';
		e.target.style.height = `${e.target.scrollHeight}px`;
		setHasValue(e.target.value !== '');
	};

	return (
		<div className={clsx('w-full h-full ', className)}>
			<div className="relative">
				<textarea
					data-slot="textarea"
					id={inputId}
					placeholder={text}
					className={clsx(
						`peer w-full bg-white placeholder:text-transparent text-blue text-sm min-h-[100px] max-h-[200px] 
   							outline outline-1 focus:outline-2 hover:outline-2 rounded-[6px] p-3 transition duration-300 ease 
   							${ error ? 'focus:outline-error hover:outline-error outline-error' : 'focus:outline-blue outline-gray-300' }`, textAreaClass
						)}
					{...register}
					name={name}
					onChange={(e) => {
						handleChange(e);
						register.onChange(e);
					}}
				/>
				<label
					htmlFor={inputId}
					className={`
          				absolute cursor-text bg-white rounde-[6px] px-1 left-2.5 text-[16px] transition-all transform origin-left
            			peer-placeholder-shown:top-[16px] peer-placeholder-shown:text-[16px] peer-placeholder-shown:scale-90
            			peer-focus:-top-2 peer-focus:left-2.5 peer-focus:text-sm peer-focus:scale-90
            			-top-2 scale-90 ${error ? 'text-error peer-focus:text-error' : 'text-blue'}
          				${hasValue && 'text-sm'}`}
				>
					{text}
					{isRequired ? <span> *</span> : ''}
				</label>
				{error && (
					<p className="mt-[6px] px-[16px] text-[12px] text-error leading-3">{error}</p>
				)}
			</div>
		</div>
	);
}
